import { VariantFragment } from '@graphql/generated/graphql';

export const isVariantInStock = (variant: VariantFragment): boolean =>
    variant.Availability === 'inStock';

export const isVariantOutOfStock = (variant: VariantFragment): boolean =>
    variant.Availability === 'outOfStock';

export const isVariantDeleted = (variant: VariantFragment): boolean =>
    variant.Availability === 'deleted';
